/* eslint-disable react/prop-types */
import React from 'react';
import debounce from 'lodash/debounce';
import classNames from 'classnames';
import Price from '../../price';

const addToCartUrl = '/add-to-cart';

class CrossSellCollectionSlide extends React.Component {
  handleAddToCart = debounce(async () => {
    const { item } = this.props;
    const { productThemeId, handleResponseMessage } = this.state;
    const formData = new FormData();

    formData.append('prism_product_id', item.product_id);
    formData.append('theme', item.theme_id);
    formData.append('copies', 1);

    this.setState({ requestInProgress: productThemeId });
    const response =
      (await this.fetchRequest(addToCartUrl, formData, 'POST')) || [];

    if (response.error) {
      this.setState({ requestInProgress: undefined });
      return handleResponseMessage(response.error);
    }

    /* eslint-disable no-undef */
    const itemsInCart = App.order.no_items;
    App.order.setProperties({ no_items: itemsInCart + 1 }); // update cart
    /* eslint-enable no-undef */

    if (window.country_name === 'US') {
      window.ga('set', 'utm_source', window.store);
      window.ga('set', 'utm_medium', 'recommendation');
      window.ga('set', 'utm_campaign', 'upsell_cross_sell');
      window.ga(
        'send',
        'event',
        'Recommendation',
        'AddToCart',
        'Cross sell OR Upsell',
        item.title
      );
    }

    this.setState(prevState => {
      const { productsAddedToCart } = prevState;
      productsAddedToCart[productThemeId] = response.prism_id;

      return {
        productsAddedToCart,
        requestInProgress: undefined,
      };
    });

    return handleResponseMessage(response.success);
  }, 700);

  handleRemoveFromCart = debounce(async () => {
    const {
      productThemeId,
      productsAddedToCart,
      handleResponseMessage,
    } = this.state;
    const prismId = productsAddedToCart[productThemeId];
    const formData = new FormData();

    formData.append('soft', false);

    this.setState({ requestInProgress: productThemeId });
    const response =
      (await this.fetchRequest(
        `${addToCartUrl}/${prismId}`,
        formData,
        'DELETE'
      )) || [];

    if (response.error) {
      this.setState({ requestInProgress: undefined, productsAddedToCart: {} });
      return handleResponseMessage(response.error);
    }

    /* eslint-disable no-undef */
    const itemsInCart = App.order.no_items;
    App.order.setProperties({ no_items: itemsInCart - 1 }); // update cart
    /* eslint-enable no-undef */

    this.setState(prevState => {
      const { productsAddedToCart: prevProductsAddedToCart } = prevState;
      delete prevProductsAddedToCart[productThemeId];

      return {
        prevProductsAddedToCart,
        requestInProgress: undefined,
      };
    });

    return handleResponseMessage(undefined);
  }, 700);

  constructor(props) {
    super(props);

    const { item } = this.props;

    this.state = {
      productThemeId: `${item.product_id}_${item.theme_id}`,
      productsAddedToCart: {},
      requestInProgress: undefined,
      handleResponseMessage: props.handleResponseMessage,
    };
  }

  fetchRequest = async (url, formData, method) => {
    const response = await fetch(url, {
      method,
      body: formData,
      credentials: 'same-origin',
    });

    if (!response.ok) {
      throw new Error(response.statusText);
    }

    return response.json();
  };

  inCart = () => {
    const { productThemeId, productsAddedToCart } = this.state;

    return Object.keys(productsAddedToCart).includes(productThemeId.toString());
  };

  renderAddToCartButton = () => {
    const { item } = this.props;
    const { requestInProgress } = this.state;

    if (this.inCart()) {
      return (
        <button
          type="button"
          className={classNames(
            'btn btn-outline-dark carousel-added-to-cart-button',
            { 'bg-light btn-progress': requestInProgress }
          )}
          disabled={requestInProgress}
          onClick={() => {
            this.handleRemoveFromCart(item);
          }}>
          {this.renderButtonContent(requestInProgress, 'Added')}
        </button>
      );
    }
    return (
      <button
        type="button"
        className={classNames(
          'btn btn-outline-dark carousel-add-to-cart-button',
          { 'bg-light btn-progress': requestInProgress }
        )}
        disabled={requestInProgress}
        onClick={() => {
          this.handleAddToCart(item);
        }}>
        {this.renderButtonContent(requestInProgress, 'Add to cart')}
      </button>
    );
  };

  renderButtonContent = (requestInProgress, text) => {
    if (requestInProgress) {
      // render Spinner
      return (
        <b
          className="btn-progress-spinner cross-sell"
          style={{ width: '40px', height: '40px' }}>
          <b className="btn-progress-spinner-icon" />
        </b>
      );
    }

    return text;
  };

  render() {
    const { item } = this.props;

    return (
      <div className="border-0 card cross-sell-collection-item d-flex flex-column shadow-none">
        <div className="card-image thumbnail">
          <div className="product-image pb-2">
            <img
              className="image-fluid m-auto"
              src={item.thumbnails[0]}
              alt={item.title}
            />
          </div>
        </div>
        <div className="align-content-end card-body p-1">
          <div className="cross-sell-product-info d-flex flex-column text-left mb-3">
            <strong className="row m-0">
              <span>{item.theme_title}</span>
            </strong>
            <span>{item.title}</span>
            <strong>
              <Price now={item.unit_prices[0].price} />
            </strong>
          </div>
          <div>{this.renderAddToCartButton()}</div>
        </div>
      </div>
    );
  }
}

export default CrossSellCollectionSlide;
